var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.647.149c-.078.09-.579 1.413-1.119 2.93-.552 1.516-1.298 3.341-1.657 4.048-1.324 2.57-3.535 5.051-5.977 6.67-1.632 1.093-2.634 1.555-5.937 2.75C.18 17.55-.205 17.77.077 18.207c.09.141 1.26.63 2.88 1.22 3.303 1.196 4.305 1.658 5.937 2.75 2.442 1.62 4.653 4.1 5.977 6.671.36.707 1.105 2.532 1.644 4.048.553 1.517 1.08 2.84 1.17 2.944.09.102.283.14.476.09.27-.065.424-.386 1.233-2.674.515-1.44 1.196-3.149 1.504-3.817a18.03 18.03 0 0 1 8.251-8.43c.617-.31 2.16-.939 3.432-1.389 3.598-1.298 3.431-1.22 3.38-1.67-.039-.373-.078-.399-2.93-1.44-1.594-.578-3.394-1.298-3.985-1.606a17.92 17.92 0 0 1-8.148-8.367c-.308-.668-.977-2.365-1.49-3.779-.502-1.413-.99-2.608-1.068-2.66-.23-.154-.552-.116-.694.052",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.143,
    y1: 37.815,
    x2: 51.719,
    y2: -18.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#077ee0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04457a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1Icon);
export default __webpack_public_path__ + "static/media/star1_icon.e428fa8ddb16c7b2bed3f129deb003ed.svg";
export { ForwardRef as ReactComponent };